// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeVenue_home-venue__2tUTt {
  display: flex;
  padding: 100px 24px 24px;
  margin-bottom: 42px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  background: var(--background-color-1);
}
.HomeVenue_home-venue__2tUTt .HomeVenue_home-venue__container__ZMQGD {
  display: flex;
  align-items: center;
  gap: 48px;
  align-self: stretch;
}
.HomeVenue_home-venue__2tUTt .HomeVenue_home-venue__left__XJQdk {
  flex: 5 1;
  aspect-ratio: 753/578;
  align-self: stretch;
  position: relative;
  margin-bottom: -60px;
}
.HomeVenue_home-venue__2tUTt .HomeVenue_home-venue__left--image__nIO61 {
  height: 100%;
  object-fit: cover;
}
.HomeVenue_home-venue__2tUTt .HomeVenue_home-venue__left--image__container__2osfg {
  height: 100%;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%;
  border-radius: 32px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}
.HomeVenue_home-venue__2tUTt .HomeVenue_home-venue__right__uXws- {
  flex: 3 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 32px;
}
.HomeVenue_home-venue__2tUTt .HomeVenue_home-venue__right--title__OGBqx {
  color: var(--accent-color);
  font-size: 32px;
}
.HomeVenue_home-venue__2tUTt .HomeVenue_home-venue__right--description__cacT- {
  color: var(--text-1);
}
.HomeVenue_home-venue__2tUTt .HomeVenue_home-venue__right--button__BP\\+5f {
  background-color: var(--accent-color);
  text-transform: initial;
}
.HomeVenue_home-venue__2tUTt .HomeVenue_home-venue__right--button__BP\\+5f svg {
  fill: white;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/Home/Components/HomeVenue/HomeVenue.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,wBAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qCAAA;AACF;AAEI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAAN;AAEI;EACE,SAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;AAAN;AAEM;EACE,YAAA;EACA,iBAAA;AAAR;AAEQ;EACE,YAAA;EACA,OAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,mBAAA;EACA,+CAAA;AAAV;AAKI;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;AAHN;AAKM;EACE,0BAAA;EACA,eAAA;AAHR;AAMM;EACE,oBAAA;AAJR;AAOM;EACE,qCAAA;EACA,uBAAA;AALR;AAOQ;EACE,WAAA;AALV","sourcesContent":[".home-venue {\n  display: flex;\n  padding: 100px 24px 24px;\n  margin-bottom: 42px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  align-self: stretch;\n  background: var(--background-color-1);\n\n  .home-venue {\n    &__container {\n      display: flex;\n      align-items: center;\n      gap: 48px;\n      align-self: stretch;\n    }\n    &__left {\n      flex: 5;\n      aspect-ratio: 753/578;\n      align-self: stretch;\n      position: relative;\n      margin-bottom: -60px;\n\n      &--image {\n        height: 100%;\n        object-fit: cover;\n\n        &__container {\n          height: 100%;\n          left: 0;\n          overflow: hidden;\n          position: absolute;\n          top: 0;\n          width: 100%;\n          border-radius: 32px;\n          box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n        }\n      }\n    }\n\n    &__right {\n      flex: 3;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: flex-start;\n      gap: 32px;\n\n      &--title {\n        color: var(--accent-color);\n        font-size: 32px;\n      }\n\n      &--description {\n        color: var(--text-1);\n      }\n\n      &--button {\n        background-color: var(--accent-color);\n        text-transform: initial;\n\n        svg {\n          fill: white;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"home-venue": `HomeVenue_home-venue__2tUTt`,
	"home-venue__container": `HomeVenue_home-venue__container__ZMQGD`,
	"home-venue__left": `HomeVenue_home-venue__left__XJQdk`,
	"home-venue__left--image": `HomeVenue_home-venue__left--image__nIO61`,
	"home-venue__left--image__container": `HomeVenue_home-venue__left--image__container__2osfg`,
	"home-venue__right": `HomeVenue_home-venue__right__uXws-`,
	"home-venue__right--title": `HomeVenue_home-venue__right--title__OGBqx`,
	"home-venue__right--description": `HomeVenue_home-venue__right--description__cacT-`,
	"home-venue__right--button": `HomeVenue_home-venue__right--button__BP+5f`
};
export default ___CSS_LOADER_EXPORT___;
